import { useImpactChartContext } from '../../../context';
import { DimensionRowProps } from '../types';
import { MultiseriesMiddlePart } from './multi-series';
import { SingleSeriesMiddlePart } from './single-series';

export function DimensionRowMiddlePart(props: DimensionRowProps) {
  const { data } = useImpactChartContext();
  if (data.length === 1) {
    return <SingleSeriesMiddlePart {...props} />;
  } else {
    return <MultiseriesMiddlePart {...props} />;
  }
}
